export var plotlyDefaultColorscales = ["Greys", "YlGnBu", "Greens", "YlOrRd", "Bluered", "RdBu", "Reds", "Blues", "Picnic", "Rainbow", "Portland", "Jet", "Hot", "Blackbody", "Earth", "Electric", "Viridis", "Cividis"];
export var removeTraceByName = function removeTraceByName(traces, traceName) {
  var index = traces.findIndex(function (item) {
    return item.name === traceName;
  }); // index == -1, if no element found

  if (index != -1) {
    traces.splice(index, 1);
  }
};
export var findTraceIndexByName = function findTraceIndexByName(traces, traceName) {
  // index == -1, if no element found
  return traces.findIndex(function (item) {
    return item.name === traceName;
  });
};